import { store } from '@/store'
import Config from '@/config'
import {
	RouteNotFound,
	RouteProfile,
	RouteLogin,
} from './routes'

export const memberAccessGuard = (to) => {
	if (!store.getters.isAuthenticated) {
		return {
			name: RouteLogin,
			replace: true,
			query: {
				redirect: to.fullPath
			}
		}
	}
}


export const redirectToProfileGuard = (to) => {
	if (store.getters.isAuthenticated) {
		return {
			name: RouteProfile,
			replace: true
		}
	}
}

export const oauthFlowGuard = (to) => {
	if (!store.getters.isOAuthFlow) {
		return {
			name: RouteNotFound,
			replace: true
		}
	}
}

export const requiredQueryParamsGuard = paramNames => (to) => {
	const hasMissingParams = paramNames.some(param =>
		to.query[param] == null || to.query[param] === '')

	if (hasMissingParams) {
		Config.isLoggingEnabled && console.warn('requiredQueryParamsGuard: missing query params', paramNames, to.query)

		return {
			name: RouteNotFound,
			replace: true
		}
	}
}
